var loadJs;

loadJs = function(urls, cb, onLoad) {
  var load;
  if (urls == null) {
    urls = [];
  }
  if (cb == null) {
    cb = _.noop;
  }
  if (onLoad == null) {
    onLoad = false;
  }
  if (!_.isArray(urls)) {
    urls = [urls];
  }
  load = function() {
    return $.when.apply(window, _.map(urls, function(url) {
      return $.ajax({
        url: url,
        dataType: 'script',
        cache: true
      });
    })).done(cb);
  };
  if (onLoad) {
    return $(window).load(load);
  }
  return load();
};

module.exports = {
  getLegalDisclaimerText: function(env) {
    var privacyStatement, termsOfUse;
    termsOfUse = I18n.t('js.modules.applepay.terms_of_use');
    privacyStatement = I18n.t('js.modules.applepay.privacy_statement');
    return I18n.t("js.modules.applepay." + env + ".legal_disclaimer", {
      termsOfUse: '<a href="/terms">' + termsOfUse + '</a>',
      privacyStatement: '<a href="/privacy">' + privacyStatement + '</a>'
    });
  },
  lazyLoadJs: function(urls, fn, onLoad) {
    return loadJs(urls, fn, onLoad);
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9hcHBsZXBheS9mcm9udGVuZC9oZWxwZXJzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2FrZXNoYXJpL25hcGlzdHJhbm8vYnVpbGQvMTQ5NTY2MDg5ODI0OS00Mzk2L3Byb2R1Y3Rpb24tMjAxNy4wNS4yNF8yMS4xOS9kZWFsL21vZHVsZXMvYXBwbGVwYXkvZnJvbnRlbmQvaGVscGVycy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxNQUFBLEdBQVMsU0FBQyxJQUFELEVBQVUsRUFBVixFQUFxQixNQUFyQjtBQUNQLE1BQUE7O0lBRFEsT0FBSzs7O0lBQUksS0FBRyxDQUFDLENBQUM7OztJQUFNLFNBQVM7O0VBQ3JDLElBQUEsQ0FBcUIsQ0FBQyxDQUFDLE9BQUYsQ0FBVSxJQUFWLENBQXJCO0lBQUEsSUFBQSxHQUFPLENBQUMsSUFBRCxFQUFQOztFQUNBLElBQUEsR0FBTyxTQUFBO1dBQUcsQ0FBQyxDQUFDLElBQUksQ0FBQyxLQUFQLENBQWEsTUFBYixFQUFzQixDQUFDLENBQUMsR0FBRixDQUFNLElBQU4sRUFBWSxTQUFDLEdBQUQ7YUFBUyxDQUFDLENBQUMsSUFBRixDQUFPO1FBQUMsS0FBQSxHQUFEO1FBQU0sUUFBQSxFQUFVLFFBQWhCO1FBQTBCLEtBQUEsRUFBTyxJQUFqQztPQUFQO0lBQVQsQ0FBWixDQUF0QixDQUF5RixDQUFDLElBQTFGLENBQStGLEVBQS9GO0VBQUg7RUFDUCxJQUErQixNQUEvQjtBQUFBLFdBQU8sQ0FBQSxDQUFFLE1BQUYsQ0FBUyxDQUFDLElBQVYsQ0FBZSxJQUFmLEVBQVA7O1NBQ0EsSUFBQSxDQUFBO0FBSk87O0FBTVQsTUFBTSxDQUFDLE9BQVAsR0FDRTtFQUFBLHNCQUFBLEVBQXdCLFNBQUMsR0FBRDtBQUN0QixRQUFBO0lBQUEsVUFBQSxHQUFhLElBQUksQ0FBQyxDQUFMLENBQU8sa0NBQVA7SUFDYixnQkFBQSxHQUFtQixJQUFJLENBQUMsQ0FBTCxDQUFPLHVDQUFQO1dBQ25CLElBQUksQ0FBQyxDQUFMLENBQU8sc0JBQUEsR0FBdUIsR0FBdkIsR0FBMkIsbUJBQWxDLEVBQ0U7TUFBQSxVQUFBLEVBQVksbUJBQUEsR0FBc0IsVUFBdEIsR0FBbUMsTUFBL0M7TUFDQSxnQkFBQSxFQUFrQixxQkFBQSxHQUF3QixnQkFBeEIsR0FBMkMsTUFEN0Q7S0FERjtFQUhzQixDQUF4QjtFQU1BLFVBQUEsRUFBWSxTQUFDLElBQUQsRUFBTyxFQUFQLEVBQVcsTUFBWDtXQUFzQixNQUFBLENBQU8sSUFBUCxFQUFhLEVBQWIsRUFBaUIsTUFBakI7RUFBdEIsQ0FOWiJ9
